<template>
  <div v-if="group != null" id="show-group-banner-footer">
    <div>
      <v-dialog v-model="dialogForBannerFooter" persistent max-width="300">
        <template v-slot:activator="{ on }" class="d-flex">
          <v-btn v-if="isGrantedUser()" v-on="on" text :loading="loading">
            <v-icon left>mdi-upload</v-icon>
            Charger
          </v-btn>
          <v-btn
            v-if="isGrantedUser()"
            :disabled="!hasResource"
            text
            @click="openDeleteDialog(group)"
            :loading="loading"
          >
            <v-icon left>mdi-delete</v-icon>
            Supprimer
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="primary-background">
            <span
              >Chargement du
              {{ type === "banner" ? "bandeau" : "footer" }}</span
            >
          </v-card-title>
          <v-card-text>
            <v-form ref="bannerFooterFormRef">
              <v-file-input
                :rules="bannerFooter_fileRules"
                v-model="bannerFooterFile"
                :label="type === 'banner' ? 'Bandeau' : 'Footer'"
              ></v-file-input>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogForBannerFooter = false">
              Fermer
            </v-btn>
            <v-btn color="primary" dark @click="triggerUploadBannerFooter">
              Enregistrer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <delete-dialog
      :open.sync="deleteDialog"
      v-on:delete="triggerRemoveBannerFooter"
    >
      <template #title>
        Suppression du {{ type === "banner" ? "bandeau" : "footer" }} pour
        {{ group.description }}
      </template>
      Vous êtes sur le point de supprimer le
      {{ type === "banner" ? "bandeau" : "footer" }} de ce groupe. Tous les
      portails héritant de ce groupe seront affectés. Voulez-vous continuer ?
    </delete-dialog>
  </div>
</template>
<script>
import { toRefs, ref, computed } from "@vue/composition-api";
import { useGroupBannerFooter } from "../../composables/group-banner-footer";
import DeleteDialog from "@/components/General/DeleteDialog.vue";
import { useRoles } from "../../composables/roles";

export default {
  props: {
    group: Object,
    type: String,
  },
  components: {
    DeleteDialog,
  },
  setup(props, { emit }) {
    /* Import des API */
    const {
      groupBannerFooterData,
      uploadBannerFooter,
      removeBannerFooter,
    } = useGroupBannerFooter();
    const { isGrantedUser } = useRoles();

    /* Variables */
    const loading = ref(false);

    /* Computed */
    const hasResource = computed(function () {
      if (props.type === "banner") {
        return props.group.bannerPath.indexOf("/banner") > -1;
      } else {
        return props.group.footerPath.indexOf("/footer") > -1;
      }
    });

    /* Méthodes */
    const openDeleteDialog = function (group) {
      groupBannerFooterData.deleteDialog = true;
      groupBannerFooterData.editedItem = { ...group };
    };
    const closeDeleteDialog = function () {
      groupBannerFooterData.deleteDialog = false;
      groupBannerFooterData.editedItem = null;
    };
    const triggerRemoveBannerFooter = async function () {
      loading.value = true;
      await removeBannerFooter(groupBannerFooterData.editedItem.id, props.type);
      loading.value = false;
      closeDeleteDialog();
      emit("refresh-preview");
    };
    const triggerUploadBannerFooter = async function () {
      groupBannerFooterData.dialogForBannerFooter = false;
      loading.value = true;
      await uploadBannerFooter(props.group.id, props.type);
      loading.value = false;
      emit("refresh-preview");
    };

    return {
      uploadBannerFooter,
      ...toRefs(groupBannerFooterData),
      removeBannerFooter,
      loading,
      hasResource,
      openDeleteDialog,
      triggerRemoveBannerFooter,
      triggerUploadBannerFooter,
      isGrantedUser,
    };
  },
};
</script>
